module.exports = __webpack_public_path__ + "static/media/copy-to-clipboard.2ab6b3d1.svg";